import URI from 'urijs';

export function isSDK(href = window.location.href) {
  const uri = new URI(href);
  return uri.search(true).isSDK === 'true';
}

export function isSDKPhase2Enabled(href = window.location.href) {
  const uri = new URI(href);
  return isSDK(href) && uri.search(true).isSDKPhase2Enabled === 'true';
}

export function getSDKParams(href = window.location.href) {
  const uri = new URI(href);
  const search = uri.search(true);
  return {
    finalUrl: search.finalUrl || '',
    mkt: search.mkt || 'en-us',
    country: search.country || 'US',
    campaignNamePrefix: decodeURIComponent(search.campaignNamePrefix || 'SDK'),
  };
}

export function getSDKCampaignName(href = window.location.href) {
  const prefix = getSDKParams(href).campaignNamePrefix;

  return `${prefix}-Performance-Max-${Date.now()}`;
}

export function getLanguageFromMkt(mkt: string) {
  const languageMap: Record<string, string> = {
    'en-us': 'English',
    'de-de': 'German',
    'fr-fr': 'French',
    'it-it': 'Italian',
    'ja-jp': 'Japanese',
    'es-es': 'Spainish',
    'pt-br': 'Portuguese',
    'zh-tw': 'TraditionalChinese',
  };

  return languageMap[mkt] || 'English';
}

export function getFinalURL(href = window.location.href) {
  return getSDKParams(href).finalUrl;
}

export function isSdkLoginCompleted(href = window.location.href) {
  const uri = new URI(href);
  return uri.search(true).sdkLoginCompleted === 'true';
}

export const isSDKUrlParam = 'isSDK';

export const isSDKCouponEnabledParam = 'isSDKCouponEnabled';

export const isSDKSignupNewCustomerParam = 'isSdkSignupNewCustomer';

export function isFirefoxSDKSignupScenario() {
  /* istanbul ignore next */
  return isSDK() && navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && window.location.href.toLowerCase().indexOf('pmaxlite/signup') !== -1;
}

export function getSignoutUrl() {
  const isSignupFlow = window.location.pathname.toLowerCase().indexOf('signup') !== -1;
  const sdkLoginPagePath = `campaign/sdk?RURL=${encodeURIComponent(window.location.href)}&sdksignup=${isSignupFlow}`;
  return `${window.location.protocol}//${window.location.host}/${sdkLoginPagePath}`;
}
